import styled from "styled-components";

export const ModalContainer = styled.div`
  width: 100%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  /* overflow: hidden; */
  max-height: 90dvh;
  /* overflow-y: auto; */
  max-width: 400px;
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0a1424;
  position: relative;
  z-index: 1000;
`;

export const ModalTitle = styled.h2`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;

  font-weight: 600;

  letter-spacing: -0.09px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: #fff;

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalContent = styled.div`
  padding: 16px;

  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  text-align: center;
`;

export const ModalMessage = styled.p`
  color: #fff;
  text-align: left;
  font-family: Figtree;
  font-size: 14px;
  opacity: 0.5;
  font-weight: 400;
  line-height: 21px; /* 133.333% */
`;

export const ModalLabel = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  letter-spacing: -0.21px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  width: 100%;
`;
export const Select = styled.div`
  display: flex;
  height: 44px;
  padding: 12px;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;
  width: 100%;

  cursor: pointer;
`;
export const SelectValue = styled.span`
  color: #fff;
  font-family: Figtree;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.07px;

  display: -webkit-box;
  -webkit-line-clamp: 1; /* Maksimalno 3 reda */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const SelectList = styled.div`
  display: flex;
  width: 100%;
  position: absolute;
  padding: 16px 14px;
  z-index: 2;
  flex-direction: column;
  left: 0;
  right: 0;
  top: calc(17px + 44px + 16px);

  max-height: calc(20px * 10 + 16px * 9 + 32px);
  overflow: auto;

  border-radius: 16px;
  border: 1px solid #345884;
  background: #142743;
`;

export const SelectListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding-top: 8px;
  padding-bottom: 8px;

  transition: all 0.3s ease-in-out;

  opacity: ${({ $disabled }) => ($disabled ? "0.5" : "1")};

  &:hover {
    padding-left: 8px;
  }

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

export const SelectListValue = styled.span`
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const CancelButton = styled.button`
  display: flex;
  width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  outline: none;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  width: 100%;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.4);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  display: flex;
  min-width: 110px;
  height: 40px;
  width: 100%;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: ${({ $type }) => {
    switch ($type) {
      case "danger":
        return "linear-gradient(135deg, #ff4757, #ff3838)";
      case "success":
        return "linear-gradient(135deg, #2877D9, #c4057a)";
      case "primary":
      default:
        return "#fff";
    }
  }};
  border: none;
  outline: none;

  color: ${({ $type }) => ($type === "primary" ? "#081120" : "#ffffff")};
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: ${({ $type }) => {
      switch ($type) {
        case "danger":
          return "0 4px 15px rgba(255, 71, 87, 0.3)";
        case "success":
          return "0 4px 15px rgba(163, 0, 94, 0.3)";
        case "primary":
        default:
          return "0 4px 15px rgba(0, 0, 0, 0.1)";
      }
    }};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
`;
